import {Box, Paper, Stack, Typography} from '@mui/material';
import {ExamModule} from '@cp/model';

export interface StudyPageContentProps {
  topic: string;
  examModule?: ExamModule;
  subjectColor: {bg: string; border: string};
  children: React.ReactNode;
}

export default function StudyPageContent({topic, examModule, subjectColor, children}: StudyPageContentProps) {
  return (
    <Paper
      sx={{
        p: {xs: 2, md: 4},
        background: `linear-gradient(135deg, ${subjectColor.bg} 0%, ${subjectColor.border}15 100%)`,
        border: `2px solid ${subjectColor.border}`,
        borderRadius: 3,
      }}
      data-testid="study-page-content"
    >
      <Stack spacing={{xs: 2, md: 3}}>
        <Box>
          <Typography
            variant="h4"
            sx={{fontWeight: 700, mb: 1, color: subjectColor.border}}
            data-testid="study-page-topic-title"
          >
            {topic}
          </Typography>
          {examModule && (
            <Typography variant="body1" color="text.secondary" data-testid="study-page-module-name">
              {examModule.name}
            </Typography>
          )}
        </Box>
        {children}
      </Stack>
    </Paper>
  );
}
